<template>

    <div class="container">

        <div class="handle-box-search">




            <el-button icon="el-icon-refresh-right" @click="refresh">刷新</el-button>

        </div>

        <!-- 表格 -->
        <el-table :data="tableData" style="width: 100%" ref="multipleTable" header-cell-class-name="table-header"
                  @selection-change="handleSelectionChange">



            <el-table-column prop="admin_name" label="发放人">
            </el-table-column>

            <el-table-column prop="distance" label="距离">
                <template slot-scope="scope">
                    {{scope.row.distance}}米
                </template>
            </el-table-column>


            <el-table-column prop="level_set.alias" label="坐标点">
                <template slot-scope="scope">
                    {{scope.row.lng}},{{scope.row.lat}}
                </template>
            </el-table-column>

            <el-table-column prop="num" label="数量">
            </el-table-column>

            <el-table-column prop="surplus_num" label="剩余数量">
            </el-table-column>


            <el-table-column prop="price" label="金额">
                <template slot-scope="scope">
                    {{scope.row.price}}元
                </template>
            </el-table-column>


            <el-table-column prop="is_del" label="是否删除">
            </el-table-column>



            <el-table-column label="操作">
                <template slot-scope="scope">

                    <el-button type="primary"
                                 @click="edit_isShow = !edit_isShow; edit_data = scope.row.positioning_reward_code;">

                        查看



                    </el-button>

                </template>
            </el-table-column>

        </el-table>

        <!-- 分页组件 -->
        <div class="pagination">
            <pages :search_data="search_data" :result_data="result_data" @pages_function="pages_function"></pages>
        </div>




        <!-- 添加组件 -->

        <!-- 编辑组件 -->
        <positioningRewardDetails :isShow="edit_isShow" :data="edit_data" @onSubmit="driverPositioningRewardLists"></positioningRewardDetails>

    </div>

</template>

<script>
    import positioningRewardDetails from './positioningRewardDetails.vue';
    // import editDriverDan from './editDriverDan.vue';
    var _this;
    export default {
        components: {
            positioningRewardDetails,
            // editDriverDan

        },

        data() {
            return {


                add_isShow: false,

                edit_isShow: false,
                edit_data: '',



                // 存放表格数据
                tableData: [],

                //翻页数据
                search_data: {
                    page: 1,
                    limit: 10,
                },

                result_data: [],
                search_rules: {
                    page: {
                        placeholder: '页码',
                        rules: {
                            required: true,
                            message: '页码需要大于0',
                            regulation: 'gt',
                            rulesData: 0
                        }
                    },
                    limit: {
                        placeholder: '每页个数',
                        rules: {
                            required: true,
                            message: '每页个数需在1-51之内',
                            regulation: 'between',
                            rulesData: [1, 51]
                        }
                    },

                },
            };
        },
        created() {
            _this = this;
            _this.driverPositioningRewardLists();
        },

        methods: {







            // 搜索司机日志列表
            driverPositioningRewardLists() {
                _this.$post(
                    "/driver/driverPositioningRewardLists",
                    _this.search_data,
                    _this.search_rules
                )
                    .then(res => {


                        // 将请求的数据存放到表格数据数组中
                        _this.tableData = res.data;
                        _this.result_data = res;

                    }).catch((err) => {

                })
            },
            //翻页组件的回调
            pages_function(search_data) {

                //赋值
                _this.search_data = search_data;
                //初始化列表
                _this.driverPositioningRewardLists();

            },

            handleSelectionChange(val) {

                var datalist = [];

                for (var i in val) {

                    datalist.push(val[i].driver_code);

                }
                _this.delDriverSubmit_data.driver_code_array = datalist;
            },
            // 刷新按钮
            refresh() {
                this.$router.go(0);
            },

        }
    };
</script>

<style scoped>
    .handle-box {
        margin-bottom: 20px;
    }

    .handle-select {
        width: 120px;
    }

    .handle-input {
        width: 200px;
        display: inline-block;
    }

    .table {
        width: 100%;
        font-size: 14px;
    }

    .red {
        color: #ff0000;
    }

    .mr10 {
        margin-right: 10px;
    }

    .table-td-thumb {
        display: block;
        margin: auto;
        width: 40px;
        height: 40px;
    }

    .el-table__row {
        height: 100px;
    }

    .el-form-item.el-form-item--small {
        width: 100%;
    }

    .demo-table-expand {
        font-size: 0;
    }

    .demo-table-expand label {
        width: 90px;
        color: #99a9bf;
    }

    .demo-table-expand .el-form-item {
        margin-right: 0;
        margin-bottom: 0;
    }

    .el-form-item__content span {
        display: inline-block;
        width: 100%;
        word-wrap: break-word;
        white-space: normal;
    }
</style>